import React from 'react';
import { BsFolder } from 'react-icons/bs';
import { FaChevronDown, FaChevronRight, FaPlus } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import {
	setDocumentTable,
	setSubDocumentTable
} from '../../../redux/actions/TablesQuickAcessAction';
import './tableList.css';

const topics = [
	'All',
	'Accepted',
	'Featured',
	'Pending',
	'Addit review',
	'Rejected'
];
const users = [
	'All',
	'Active',
	'Premium',
	'Not active',
	'Uninstalls',
	'Ag Uninstalls'
];
const dashboards = ['All', 'Default', 'Non Default'];
const referral = ['With Referral', 'No Referral'];

const QuickAccessTables = () => {
	const { selectedDocumentTable, selectedSubDocumentTable } = useTypedSelector(
		(state) => state.tablesQuickAccess
	);

	const checkIfTableIsSelected = (name: string): boolean => {
		return selectedDocumentTable === name ? true : false;
	};

	return (
		<div className="channel-bar children-sider-bar">
			<TitleBlock />
			<div className="channel-container">
				<Dropdown
					header="Topics"
					selections={topics}
					isExpanded={checkIfTableIsSelected('Topics')}
					selectedSubDocument={selectedSubDocumentTable}
				/>

				<Dropdown
					header="Users"
					selections={users}
					isExpanded={checkIfTableIsSelected('Users')}
					selectedSubDocument={selectedSubDocumentTable}
				/>
				<Dropdown
					header="Dashboards"
					selections={dashboards}
					isExpanded={checkIfTableIsSelected('Dashboards')}
					selectedSubDocument={selectedSubDocumentTable}
				/>
				<Dropdown
					header="Ref topics"
					selections={referral}
					isExpanded={checkIfTableIsSelected('Ref topics')}
					selectedSubDocument={selectedSubDocumentTable}
				/>
				<Dropdown
					header="Ref extensions"
					selections={referral}
					isExpanded={checkIfTableIsSelected('Ref extensions')}
					selectedSubDocument={selectedSubDocumentTable}
				/>
			</div>
		</div>
	);
};

type dropdownProps = {
	header: string;
	selections: string[];
	isExpanded: boolean;
	selectedSubDocument: string;
};

const Dropdown = ({
	header,
	selections,
	isExpanded,
	selectedSubDocument
}: dropdownProps) => {
	const dispatch = useDispatch();

	const checkIfSubTableIsSelected = (name: string): boolean => {
		return selectedSubDocument === name ? true : false;
	};

	return (
		<div className="dropdown">
			<div className="dropdown-header">
				<ChevronIcon expanded={isExpanded} />
				<h5
					className={
						isExpanded
							? 'dropdown-header-text-selected'
							: 'dropdown-header-text'
					}
					onClick={() => {
						dispatch(setDocumentTable(header, selections[0]));
					}}
				>
					{header}
				</h5>
				<FaPlus
					size="12"
					className="text-accent text-opacity-80 my-auto ml-auto invisible"
				/>
			</div>
			{isExpanded &&
				selections &&
				selections.map((selection) => (
					<DocumentSelection
						selection={selection}
						isSelected={checkIfSubTableIsSelected(selection)}
					/>
				))}
		</div>
	);
};

const ChevronIcon = ({ expanded }: { expanded: boolean }) => {
	const chevClass = `text-opacity-80 my-auto mr-1 ${
		expanded ? 'text-purple-600' : 'text-gray-800 dark:text-white'
	}`;
	return expanded ? (
		<FaChevronDown size="14" className={chevClass} />
	) : (
		<FaChevronRight size="14" className={chevClass} />
	);
};

const DocumentSelection = ({
	selection,
	isSelected
}: {
	selection: string;
	isSelected: boolean;
}) => {
	const dispatch = useDispatch();
	return (
		<div
			className={`dropdown-selection ${
				isSelected
					? 'text-gray-800 dark:text-white '
					: 'dropdown-selection-text-hover'
			}`}
		>
			<BsFolder size="20" className="mr-1" />
			<h5
				className="dropdown-selection-text "
				onClick={(e) => dispatch(setSubDocumentTable(selection))}
			>
				{selection}
			</h5>
		</div>
	);
};

const TitleBlock = () => (
	<div className="channel-block">
		<h5 className="channel-block-text">{'Documents'}</h5>
	</div>
);

export default QuickAccessTables;
